import { render } from "./RocketIcon.vue?vue&type=template&id=8de88c88&scoped=true&ts=true"
import script from "./RocketIcon.vue?vue&type=script&lang=ts"
export * from "./RocketIcon.vue?vue&type=script&lang=ts"

import "./RocketIcon.vue?vue&type=style&index=0&id=8de88c88&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8de88c88"]])

export default __exports__